export class Situacao {
  id: number;
  situacao: string;
  ativo: boolean;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/situacoes/situacao.model.ts
 **/